var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.75,
    cy: 5.75,
    r: 5.25,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M5.963 0a5.963 5.963 0 0 1 1.713 11.677L5.758 15l-2.024-3.505A5.963 5.963 0 0 1 5.963 0zm0 1.747a4.216 4.216 0 1 1 0 8.432 4.216 4.216 0 0 1 0-8.432z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.8069e04a.svg";
export { ForwardRef as ReactComponent };